import { render } from "./VentasCreate.vue?vue&type=template&id=603daa54&scoped=true"
import script from "./VentasCreate.vue?vue&type=script&lang=js"
export * from "./VentasCreate.vue?vue&type=script&lang=js"

import "./VentasCreate.vue?vue&type=style&index=0&id=603daa54&scoped=true&lang=css"

import exportComponent from "/home/runner/work/system-jj-frontend/system-jj-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-603daa54"]])

export default __exports__